export default __webpack_public_path__ + "static/media/meet5.6e23b955.png";